import { render, staticRenderFns } from "./TablaCatexperfil.vue?vue&type=template&id=5cf59834&scoped=true&"
import script from "./TablaCatexperfil.vue?vue&type=script&lang=js&"
export * from "./TablaCatexperfil.vue?vue&type=script&lang=js&"
import style0 from "./TablaCatexperfil.vue?vue&type=style&index=0&id=5cf59834&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf59834",
  null
  
)

export default component.exports